import angular from 'angular';
import { ServicesModule } from '../../services/services.module';
import { IntegrationPopoverComponent } from './integration-popover/integration-popover.component';
import { PROVIDERS } from './providers.constant';

export const CommonModule = 'mandaeApp.common';

angular
  .module(CommonModule, [
    'LocalStorageModule',
    'ui.router',
    'ui.bootstrap',
    ServicesModule,
  ])
  .component(IntegrationPopoverComponent.componentName, IntegrationPopoverComponent)
  .constant('PROVIDERS', PROVIDERS)
